import APIService from './class';

class Payroll extends APIService {
  constructor() {
    super( '/payroll' );
  }

  exportWorkerLines( token, params, options ) {
    return this.action( 'post', '/exportWorker/lines', params, options, token );
  }

  exportIncentiveLines( token, params, options ) {
    return this.action( 'post', '/exportIncentive/lines', params, options, token );
  }

  add( token, params, options ) {
    return this.action( 'post', '/add', params, options, token );
  }

  unlock( token, params, options ) {
    return this.action( 'post', '/unlock', params, options, token );
  }

  getWorkerCosts( token, params, options ) {
    params = params || {};
    return this.action( 'get', `/getWorkerCosts?id=${ params.id }`, null, options, token );
  }

  getIncidents( token, params, options ) {
    params = params || {};
    return this.action( 'get', `/incidents?start=${ params.start }&end=${ params.end }`, null, options, token );
  }

  getIncentiveCosts( token, params, options ) {
    params = params || {};
    return this.action( 'get', `/getIncentiveCosts?id=${ params.id }`, null, options, token );
  }

}

export default new Payroll();
